module.exports = __webpack_public_path__ + "img/neck_width.da8717c2.png";